import { render } from "./UsuariosEliminados.vue?vue&type=template&id=e5f5d9bc&scoped=true"
import script from "./UsuariosEliminados.vue?vue&type=script&lang=js"
export * from "./UsuariosEliminados.vue?vue&type=script&lang=js"

import "./UsuariosEliminados.vue?vue&type=style&index=0&id=e5f5d9bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5f5d9bc"]])

export default __exports__